import React from 'react';
import KGWizard from './wizard/KGWizard';

interface CreateKGModalProps {
  onClose: () => void;
  onCreated: () => void;
  hasGdsLicense: boolean;
}

const CreateKGModal: React.FC<CreateKGModalProps> = ({ onClose, onCreated, hasGdsLicense }) => (
  <KGWizard mode="kg" onClose={onClose} onCreated={onCreated} hasGdsLicense={hasGdsLicense} />
);

export default CreateKGModal;